const normalizeCompanyValue = (value) =>
  String(value ?? "").trim().toLowerCase();

export const isCoupangCompany = ({
  companyCode,
  companyName,
  companyNameEn,
} = {}) => {
  const companyValues = [companyCode, companyName, companyNameEn].map(
    normalizeCompanyValue
  );

  return companyValues.some(
    (value) => value.includes("coupang") || value.includes("쿠팡")
  );
};
